import { useTranslation } from 'react-i18next';
import { GhostIcon } from '@karma/components/icons';
import { Stack, Typography } from '@karma/components';
import Alooma from 'services/alooma';
import { getQueryParam } from 'functions/urlHelpers';
import { QUERY_PARAMS } from 'consts/queryParams';
import { Container } from './GlobalSearchEmptyState.style';

const GlobalSearchEmptyState = () => {
  const { t } = useTranslation();
  const query = getQueryParam(QUERY_PARAMS.query);

  Alooma.usePageViewTracker();

  return (
    <Container direction="column" fullWidth>
      <Stack direction="column" fullWidth>
        <GhostIcon width={60} height={60} />
        <Typography variant="h3" tMargin={32} bMargin={20}>
          {t('app:noResultsFoundFor')} “{query}”
        </Typography>
        <Typography variant="paragraphLarge">{t('app:pleaseReviewYourSpellingOrTryDifferentKeyword')}</Typography>
      </Stack>
    </Container>
  );
};

export default GlobalSearchEmptyState;
